/* eslint dom-in-jsx/no-window-calls: 0 */
/* eslint semi: 0 */
import React, { Component } from 'react';

class PasswordField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value || props.defaultValue,
      label: this.props.label,
    };
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.setState({ value: props.value });
  }

  setValue(value) {
    if (this.props.onValue) {
      this.props.onValue(value);
    } else {
      this.setState({ value: value });
    }
  }

  generatePassword() {
    this.setValue(PasswordGenerator.prototype.randomPassword());
  }

  render() {
    return (
      <div className='passwordField'>
        <input
          autoFocus={this.props.focus}
          className={this.props.className}
          disabled={this.props.disabled}
          id={this.props.id}
          name={this.props.name}
          placeholder={this.props.placeholder}
          required={this.props.required}
          type='password'
          value={this.state.value}
          onChange={(e) => this.setValue(e.target.value)}
        />
        <button
          className='ui button generate-password-button'
          disabled={this.props.disabled}
          name='generate'
          type='button'
          onClick={this.generatePassword.bind(this)}
        >
          {this.state.label}
        </button>
      </div>
    );
  }
}

module.exports = PasswordField;
